import SuiTypography from "components/SuiTypography";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import { timestampConversion, formatDateField } from "utils/common";
import TagItem from "containers/TagItem";
import Checkbox from "./Checkbox";
import { globaleDateTimeFormatter } from "utils/helper";
import { stripHtml } from "utils/helper";
import {
  getClientTableSlotMeals,
  MEAL_SLOT_KEYS,
} from "utils/perDayDietChart";

const renderMeal = (mealItems) => {
  if (!mealItems || !mealItems.length) {
    return (
      <SuiTypography variant="button" fontWeight="medium">
        N/A
      </SuiTypography>
    );
  }

  return (
    <div>
      {mealItems.map((i, index) => {
        const cleanDesc = stripHtml(i?.description || "");
        const displayText =
          cleanDesc.length > 40
            ? `${i?.name} - ${cleanDesc.slice(0, 40)}...`
            : `${i?.name} - ${cleanDesc}`;

        return (
          <div key={index}>
            <Tooltip title={cleanDesc} placement="top">
              <SuiTypography variant="button" fontWeight="medium">
                {displayText}
              </SuiTypography>
            </Tooltip>
            {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
          </div>
        );
      })}
    </div>
  );
};

export const dietChartRow = (
  dietChartArrayv1,
  selectHandler
) => {
  const countCalories = (item) => {
    let calories = 0;
    MEAL_SLOT_KEYS.forEach((key) => {
      getClientTableSlotMeals(item, key).forEach((i) => {
        calories += isNaN(i?.calories) ? 0 : i?.calories;
      });
    });
    return calories?.toFixed(2) ?? 0;
  };

  const rows = dietChartArrayv1.map((item, index) => ({
    View: (
      <Checkbox
        item={item}
        index={index}
        selectHandler={selectHandler}
      />
    ),
    "Date/Time (Added)": (
      <SuiTypography variant="button" fontWeight="medium">
        {item?.createdAt?.seconds
          ? moment(timestampConversion(item?.createdAt))
              .local()
              .format("MMMM Do YYYY, h:mm a")
          : moment(item?.createdAt).local().format("MMMM Do YYYY, h:mm a")}
      </SuiTypography>
    ),
    "Diet Date for Client": (
      <SuiTypography variant="button" fontWeight="medium">
        {item?.from && item?.to
          ? `${globaleDateTimeFormatter(
              item?.from,
              "date"
            )} to ${globaleDateTimeFormatter(item?.to, "date")}`
          : item?.date
          ? globaleDateTimeFormatter(item?.date, "date")
          : "N/A"}
      </SuiTypography>
    ),
    "Week Plan": (
      <SuiTypography variant="button" fontWeight="medium">
        {item.weekPlan}
      </SuiTypography>
    ),
    "Chart Type": (
      <SuiTypography variant="button" fontWeight="medium">
        {item.chartType}
      </SuiTypography>
    ),
    "Early Morning": renderMeal(getClientTableSlotMeals(item, "earlyMorning")),
    Breakfast: renderMeal(getClientTableSlotMeals(item, "breakfast")),
    "Mid Morning": renderMeal(getClientTableSlotMeals(item, "midMorning")),
    Brunch: renderMeal(getClientTableSlotMeals(item, "brunch")),
    "Mid Meal": renderMeal(getClientTableSlotMeals(item, "midMeal")),
    Lunch: renderMeal(getClientTableSlotMeals(item, "lunch")),
    "Post Lunch": renderMeal(getClientTableSlotMeals(item, "postLunch")),
    Evening: renderMeal(getClientTableSlotMeals(item, "evening")),
    "Before Dinner": renderMeal(getClientTableSlotMeals(item, "beforeDinner")),
    Dinner: renderMeal(getClientTableSlotMeals(item, "dinner")),
    "Post Dinner": renderMeal(getClientTableSlotMeals(item, "postDinner")),
    "Late Night": renderMeal(getClientTableSlotMeals(item, "lateNight")),
    Notes: item?.notes ? (
      <Tooltip title={stripHtml(item?.notes)} placement="top">
        <SuiTypography variant="button" fontWeight="medium">
          {stripHtml(item?.notes)?.length > 40
            ? `${stripHtml(item?.notes)?.slice(0, 40)}...`
            : stripHtml(item?.notes)}
        </SuiTypography>
      </Tooltip>
    ) : (
      <SuiTypography variant="button" fontWeight="medium">
        N/A
      </SuiTypography>
    ),
    Calories: (
      <SuiTypography variant="button" fontWeight="medium">
        <TagItem val={countCalories(item)} />
      </SuiTypography>
    ),
  }));

  return rows;
};
